import i18next from 'i18next';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import langInvestWordLang from '../../../apps/investor/langs/langInvestWordLang';
import { TInvestIsNTag } from '../../../apps/investor/types/TInvestIsNTag';

type AppFormatPercentProps = {
	value?: number | null;
	textIfNull?: string;
	addSpace?: boolean;
	isNS?: boolean;
	isN?: TInvestIsNTag;
	displayPlus?: boolean;
};

const AppFormatPercent = (props: AppFormatPercentProps) => {
	const { value, isN, isNS, textIfNull, addSpace, displayPlus } = props;

	const { t } = useTranslation();

	return (
		<>
			{isN === 'A' ? (
				t(langInvestWordLang.na.tag)
			) : isN === 'C' ? (
				t(langInvestWordLang.nc.tag)
			) : isN === 'S' ? (
				t(langInvestWordLang.ns.tag)
			) : isNS === true ? (
				t(langInvestWordLang.ns.tag)
			) : value === undefined ? (
				<>...</>
			) : value === null || value === undefined ? (
				<>{textIfNull ?? '0'}</>
			) : (
				<>
					{displayPlus && value > 0 ? '+' : ''}
					{_.round((value === 0 ? 0 : value) * 100, 2).toLocaleString(i18next.language, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
					{addSpace ? ' ' : ''}
					<small>%</small>
				</>
			)}
		</>
	);
};

export default AppFormatPercent;
